import { render, staticRenderFns } from "./NationalChallengesPage.vue?vue&type=template&id=d408d538&scoped=true"
import script from "./NationalChallengesPage.vue?vue&type=script&lang=js"
export * from "./NationalChallengesPage.vue?vue&type=script&lang=js"
import style0 from "./NationalChallengesPage.vue?vue&type=style&index=0&id=d408d538&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d408d538",
  null
  
)

export default component.exports